<template>
  <div :class="[baseCss, 'overflow-hidden', 'relative']" :style="{width, height}">
    <slot name="controls" />
    <div :style="style" :class="[`${baseCss}-wrapper`, 'overflow-y-auto']">
      <slot name="items" />
    </div>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Parallax',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('parallax', [])
    }
  },
  computed: {
    style () {
      const height = this.height
      return {
        height,
        width: this.width,
        aspectRatio: !height ? this.aspectRatio.replace(':', '/') : height
      }
    }
  },
  props: {
    aspectRatio: {
      type: String,
      default: '5:3'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String
    }
  }
}
</script>
<style>
.bcq-parallax .bcq-parallax-wrapper
{
  perspective: 300px;
  /*overscroll-behavior: contain;*/
}

.bcq-parallax .bcq-parallax-item
{
  transform-style: preserve-3d;
  z-index: 10;
}

.bcq-parallax .bcq-parallax-item-layer-back
{
  transform: translateZ(0);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bcq-parallax .bcq-parallax-item-layer-base
{
  transform: translateZ(90px) scale(.7);
}

.bcq-parallax .bcq-parallax-item-layer .bcq-table-layout
{
  height: 100%;
}

.bcq-parallax .bcq-parallax-controls
{
  z-index: 15;
}

.bcq-parallax .bcq-parallax-controls.left-0 .bcq-radio-group,
.bcq-parallax .bcq-parallax-controls.right-0 .bcq-radio-group
{
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/parallax/parallax.vue